import type { ReactNode } from "react";
import { createPortal } from "react-dom";
import styled from "styled-components";
import { StyleTransition } from "react-transitioning";

import { hexToRGB } from "../../utils/style";

/**
 * [共通パーツ]モーダル
 */

type Props = {
  children: ReactNode;
  isOpen?: boolean;
  blurBackground?: boolean;
  className?: string;
};

const styles = {
  enter: {
    opacity: 0,
  },
  enterActive: {
    opacity: 1,
    transition: "all 300ms ease-in-out",
  },
  exit: {
    opacity: 1,
  },
  exitActive: {
    opacity: 0,
    transition: "all 300ms ease-in-out",
  },
};

const BackDrop = styled.div<{ $blurBackground?: boolean }>`
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  z-index: 100;
  position: fixed;
  align-items: center;
  touch-action: none;
  justify-content: center;
  background-color: ${(props) =>
    hexToRGB(props.theme.colors.primaryShadow, 0.4)};
  ${(props) => props.$blurBackground && `backdrop-filter: blur(8px)`};
`;

const ModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  background-color: ${(props) => props.theme.colors.primaryBackground};
  overflow: hidden;
`;

const modalRoot: HTMLElement = document.getElementById("modal-root")!;

export function Modal({
  isOpen = false,
  blurBackground = false,
  children,
  className,
}: Props) {
  const modalUI = (
    <StyleTransition in={isOpen} duration={500} styles={styles} enter exit>
      <BackDrop $blurBackground={blurBackground}>
        <ModalWrapper className={className}>{children}</ModalWrapper>
      </BackDrop>
    </StyleTransition>
  );
  return createPortal(modalUI, modalRoot);
}
